import type {AppLocale} from './locales'

const STORAGE_KEY = 'eventatv_ip_locale_suggest_dismiss_v1'

type Dismiss = {rejected: string[]}

function readSet(): Set<string> {
  if (typeof window === 'undefined') return new Set()
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return new Set()
    const p = JSON.parse(raw) as Dismiss
    if (!p || !Array.isArray(p.rejected)) return new Set()
    return new Set(
      p.rejected.filter(
        (x) => typeof x === 'string' && /^[a-z]{2}:[a-z]{2}$/.test(x),
      ),
    )
  } catch {
    return new Set()
  }
}

function pairKey(from: AppLocale, to: AppLocale) {
  return `${from}:${to}` as const
}

export function isIpLocalePairDismissed(
  from: AppLocale,
  to: AppLocale,
): boolean {
  return readSet().has(pairKey(from, to))
}

export function dismissIpLocalePair(from: AppLocale, to: AppLocale) {
  if (typeof window === 'undefined') return
  try {
    const s = readSet()
    s.add(pairKey(from, to))
    const next: Dismiss = {rejected: [...s]}
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
  } catch {
    /* quota */
  }
}
